// Responsive props for images served through our /api/img/ proxy (resized WebP via ?w=). Other URLs pass through untouched.
const LEGACY_HOST = "https://static.prod-images.emergentagent.com/";
const PROXY = "/api/img/";

export function ownImage(src) {
  if (typeof src !== "string") return src;
  if (src.startsWith(LEGACY_HOST)) return PROXY + src.slice(LEGACY_HOST.length);
  return src;
}

const proxied = (src) => typeof src === "string" && (src.startsWith(PROXY) || src.includes("/api/img/"));

// widths: candidate pixel widths; sizes: CSS sizes hint. Returns { src, srcSet?, sizes? }.
export function imgProps(src, widths = [480, 800], sizes) {
  const s = ownImage(src);
  if (!proxied(s)) return { src: s };
  const base = s.split("?")[0];
  const ws = [...widths].sort((a, b) => a - b);
  return {
    src: `${base}?w=${ws[ws.length - 1]}`,
    srcSet: ws.map((w) => `${base}?w=${w} ${w}w`).join(", "),
    sizes: sizes || `${ws[ws.length - 1]}px`,
  };
}
